import React from 'react';
import Api from '../api/Api.js';
import { Redirect, Route } from 'react-router-dom';

export default (props) => {
    return <Route {...props} />;
    if (Api.isLoggedIn() && !Api.isLocked())
        return (<Route {...props} />);
    else {
        return <Route render={() => <Redirect to={Api.isLocked() ? "/lockedOut" : "/login"} />} />;
    }
}

export const AvailableRoles = ["Admin", "OpsManager", "Ops", "ProductManager", "Sales", "Client"];